export default {
	nbDossiers: 'Pas de dossiers à traiter | {n} dossier à traiter | {n} dossiers à traiter'
};
